import { Directive, ElementRef, Injector, Input, OnInit } from '@angular/core';
@Directive({
  selector: '[farris-checkbox-modification]'
})
export class FarrisCheckboxModificationDirective implements OnInit {
  @Input() index: number;
  constructor(private injector: Injector, private elementRef: ElementRef) { }
  ngOnInit(): void {
    if (typeof this.index !== 'number' || !this.elementRef) {
      return;
    }
    const nativeElement = this.elementRef.nativeElement;
    if (nativeElement) {
      const id = nativeElement.getAttribute('id');
      if (id) {
        const token = `${id}_${this.index}`;
        this.elementRef.nativeElement.setAttribute('id', token);
        this.elementRef.nativeElement.setAttribute('name', token);
        this.elementRef.nativeElement.setAttribute('original_id', id);
      }
    }
  }

}
